export const ApiConstants = {
    login: 'login',
    getLoginOtp: 'user/get-login-otp',
    forgotPassword: 'user/forgotpassword',
    changePassword: 'user/changePassword',
    updateUser: 'user/updateuser',
    getUserById: 'user/getuserinfobyemail?emailid=',
    getCurrentUser: 'user/currentuserinfo',
    captureWebFcmToken: 'user/captureWebFcmToken?webFcmToken=',
    sendMessage: 'https://fcm.googleapis.com/fcm/send',
    getUserWebNotification: 'webNotification/getUserWebNotification?userId=',
    getAllUserWebNotifications: 'webNotification/getAllUserWebNotifications?userId=',
    getRolePermissions: 'role/getrolepermissions?roleid=',
    uploadUserProfile: 'floorplan/uploaduserprofile?userId=',
    getprofilePhoto: 'user/getuserprofileurlbyuserid?userId=',
    getAllActiveCompanyInfo: 'company/get/active',
    getalltickets: 'getalltickets?companyId=',
    getallticketsbycompanyid: 'getallticketsbycompanyid?companyId=',
    getticketbasedoncompanyandstatus: 'getticketbasedoncompanyandstatus?companyId=',
    getAllCompanyList: 'company/get?page=',
    enableDisableCompany: 'company/status?id=',
    addEditCompanyInfo: 'company',
    getAllLocations: 'location/getalllocations',
    getCompanyLocationsByCompanyId: 'location/getsitecountandlocationsbycompanyid?companyId=',
    getAllSiteList: 'site/getallsitesbylocation?locationid=',
    addCity: 'location/addlocation',
    editCity: 'location/updatelocation',
    cityAudit: 'audit/getlocationaudit?id=',
    locationStatus: 'location/enabledisablelocation?locationId=',
    addSite: 'site/addSite',
    updateSite: 'site/updatesite',
    uploadSites: 'site/uploadsitelist?locationId=',
    addEditDepartment: 'project/editdepartment',
    getDepartments: 'project/department',
    uploadExcelUrl: 'myrisksecure/departmentUpload?clientCode=',
    getAllCostCenter: 'project/costcenter',
    addEditCostCenter: 'project/editcostcenter',
    costCenterUpload: 'myrisksecure/costCenterUpload?clientCode=',
    downloadProject:'',
    uploadProject:'',
    getAllProject:'',
    getActiveCostCenter:'',
    getActiveDepartment:'',
    addProject:'',
    enabledisableproject:'',
    getProjectSetupAudit:'',
    getAllTicket: 'get',
    getGroupMappingToSite: 'group/getGroupMappingToSiteBasedOnSubGroupCompanySite?companyId=',
    getAllTicketsBasedOnCompanyIds: 'getAllTicketsBasedOnCompanyIds?companyIds=',
    getAllTicketsBasedOnFilter: 'get-based-on-filter',
    addEditTicket: 'web/add-edit',
    emailreply:'emailreply',
    getEmails: 'emails?ticketId=',
    getAllContactInfo: 'user/get?page=',
    enableDisableContact: 'user/statuschange?userId=',
    getAllRoles: 'user/get/roles',
    getAllActiveSites: 'site/getactivesitesbylocationid?locationId=',
    addEditContacts: 'user',
    getAllAgentInfo: 'agent/get?page=',
    addEditAgent: 'agent',
    enableDisableAgent: 'agent/status?agentId=',
    getActiveLocationBasedonCompanyId: 'location/getallactivelocationsbycompanyid?companyId=',
    getAllJobs: 'scheduler/jobs',
    pauseScheduleJob: 'scheduler/pause?jobName=',
    resumeScheduleJob: 'scheduler/resume?jobName=',
    deleteScheduleJob: 'scheduler/delete?jobName=',
    deleteJobSetup: 'jobsetup?id=',
    addScheduleJob: 'scheduler/schedule?jobName=',
    editScheduleJob: 'scheduler/update?jobName=',
    getModuleList: 'module/getmodules',
    getAllActiveLocationsByCompanyId: 'location/getallactivelocationsbycompanyid?companyId=',
    getActiveSitesByLocationId: 'site/getactivesitesbylocationid?locationId=',
    getAllAgentBasedOnCompanyId: 'agent/getAllAgentBasedOnCompanyId?companyId=',
    getAllActiveMasterGroup: 'group/getAllActiveMasterGroup',
    getAllActiveSubGroupByMasterGroupId: 'group/getAllActiveSubGroupByMasterGroupId?masterGroupId=',
    getAllGroupSiteBasedOnSiteAndCompany: 'group/getAllMasterGroupMappingToSiteBasedOnSiteAndCompany?companyId=',
    getAllAgentsSiteAndSubgroupId: 'agent/getAllAgentsByCompanySiteAndSubgroupId?companyId=',
    getAllGroupSiteBasedOnSiteAndCompanyV1: 'group/new/getAllMasterGroupMappingToSiteBasedOnSiteAndCompany?companyId=',
    getusersbasedoncompanyandsiteid: 'user/getusersbasedoncompanyandsiteid?companyId=',
    getAllGroup: 'group/getAllMasterGroup?page=',
    getAllGroupv1: 'group/getAllMasterGroups',
    statusGroup: 'group/status/group?id=',
    addEditGroup: 'group/addedit/mastergroup',
    getAllSubGroup: 'group/getAllSubGroup?page=',
    getAllSubGroupv1: 'group/getAllSubGroups',
    statusSubGroup: 'group/status/subgroup?id=',
    addEditSubGroup: 'group/addedit/subgroup',
    getAllGroupMappingToAgentBasedOnSiteAndCompany: 'group/getAllGroupMappingToAgentBasedOnSiteAndCompany?siteId=',
    getAllGroupMappingToSite: 'group/getAllGroupMappingToSite?page=',
    statusMappingToSite: 'group/status/mappingtosite?id=',
    addEditMappingToSite: 'group/addedit/groupmappingtosite',
    getAllGroupMappingToAgent: 'group/getAllGroupMappingToAgent?page=',
    statusMappingToAgent: 'group/status/mappingtoagent?id=',
    groupMappingToAgent: 'group/addedit/groupmappingtoagent',
    activeLevel: 'escalation/getallescalationlevels',
    addEditEscalationSetup: 'escalation',
    getAllEscalationSetup: 'escalation/getallescalationmatrixsetups?page=',
    enableDisableEscalationSetup: 'escalation/status?escalationSetupId=',
    activeEscalationGroup: 'escalation/getallactivesetupgroups',
    activeEscalationMatrix: 'escalation/getallactiveescalationmatrixsetups',
    getAllEscalationGropup: 'escalation/getallsetupgroups?page=',
    addEditEscalationGroup: 'escalation/addeditsetupgroup',
    enableDisableEscalationGroup: 'escalation/setupgroupstatus?setGroupId=',
    getAllSupervisorBycompids: 'agent/get-supervisor-companyIds?companyIds=',
    getAllAdminBycompids: 'agent/get-admin-companyIds?companyIds=',
    siteAudit: 'audit/getsiteaudit?id=',
    getAllNotification: 'notification?page=',
    addEditNotification: 'notification',
    enableDisableNotification: 'notification/enabledisable?id=',
    getNotificationAudit: 'audit/getnotificationsaudit?id=',
    getRole: 'role?page=',
    enabledisablerole: 'role/enabledisable?id=',
    getRoleAudit: 'audit/getroleaudit?id=',
    addRole: 'role',
    updateRole: 'role/updateRoleAuth',
    getMenusList: 'menu/getmenus',
    getAllMenusPageable: 'menu?page=',
    enableDisableMenu: 'menu/enabledisable?id=',
    getMenuAudit: 'audit/getmenuaudit?id=',
    addMenu: 'menu',
    updateMenu: 'menu',
    markUserNotificationsAsRead: 'webNotification/markUserNotificationsAsRead',
    markTicketNotificationsAsRead: 'notification/markasreadticketnotification',
    upload: 'group/upload/excel'
}